import React from 'react'

const OKContext = React.createContext()

export default OKContext